export enum ViewQuizModeEnum {
  Enabled = 'enabled',
  Disabled = 'disabled',
  Locked = 'locked',
}

export const defaultQuizModeEnum: ViewQuizModeEnum = ViewQuizModeEnum.Enabled;
